// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .mat-selection-list {
    flex: 1 auto;
    height: 0;
    overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/messagesettings/User/add.user.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,cAAc;AAClB","sourcesContent":[":host .mat-selection-list {\n    flex: 1 auto;\n    height: 0;\n    overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
